module.exports = __webpack_public_path__ + "static/booking-493172e691fca320da3e6ff3c96e4c5b.png";